import { useEffect, useRef, useState } from "react";
import Button from "../atoms/button";
import { PIPELINE_STEPS, USE_LABELS } from "./pipelineSteps";

const BotOpsPipelineTour = ({ enabled, onFocusTab }) => {
    const [stepIndex, setStepIndex] = useState(0);
    const [simulating, setSimulating] = useState(false);
    const isMountRef = useRef(true);

    const step = PIPELINE_STEPS[stepIndex];

    useEffect(() => {
        if (!simulating) return undefined;
        if (stepIndex >= PIPELINE_STEPS.length - 1) {
            setSimulating(false);
            return undefined;
        }
        const t = setTimeout(() => {
            setStepIndex((i) => Math.min(i + 1, PIPELINE_STEPS.length - 1));
        }, 1600);
        return () => clearTimeout(t);
    }, [simulating, stepIndex]);

    useEffect(() => {
        if (isMountRef.current) {
            isMountRef.current = false;
            return;
        }
        if (step?.tab && typeof onFocusTab === "function") {
            onFocusTab(step.tab);
        }
    }, [stepIndex, step, onFocusTab]);

    const startSimulation = () => {
        setStepIndex(0);
        setSimulating(true);
    };

    const stopSimulation = () => setSimulating(false);

    return (
        <section className="rounded-lg border border-[#d59106] p-4 mb-6" aria-label="Como o bot processa uma mensagem">
            <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                    <h2 className="text-lg text-laranjinha">Como funciona uma mensagem</h2>
                    <p className="text-sm text-gray-300 mt-1 max-w-2xl">
                        Tour do pipeline real (WhatsApp → n8n → bot). Destaque amarelo = o que esta
                        página configura. Passos cinza = infraestrutura (não editável aqui).
                    </p>
                </div>
                <div className="flex flex-wrap gap-2">
                    {!simulating ? (
                        <Button
                            click={startSimulation}
                            classes="bg-[#d59106] hover:bg-[#b47c06] text-black px-3 py-1"
                        >
                            Simular mensagem
                        </Button>
                    ) : (
                        <Button click={stopSimulation} classes="bg-gray-600 hover:bg-gray-500 px-3 py-1 font-medium text-white">
                            Pausar
                        </Button>
                    )}
                </div>
            </div>

            <ol className="flex flex-wrap gap-2 mb-4">
                {PIPELINE_STEPS.map((s, i) => {
                    const active = i === stepIndex;
                    const usesConfig = s.uses.length > 0;
                    return (
                        <li key={s.id}>
                            <button
                                type="button"
                                onClick={() => {
                                    setSimulating(false);
                                    setStepIndex(i);
                                }}
                                className={`text-left text-xs sm:text-sm px-2 py-2 rounded border max-w-[9.5rem] h-full ${
                                    active
                                        ? "border-[#d59106] bg-[#d59106]/20 text-white"
                                        : usesConfig
                                          ? "border-[#b47c06]/60 bg-gray-800 hover:bg-gray-700"
                                          : "border-gray-600 bg-gray-900 text-gray-400 hover:bg-gray-800"
                                }`}
                            >
                                <span className="block font-medium leading-tight">{s.title}</span>
                                <span className="block opacity-80 mt-1 leading-tight">{s.short}</span>
                            </button>
                        </li>
                    );
                })}
            </ol>

            <div className="rounded-lg bg-gray-900/60 p-3 border border-[#b47c06]/20">
                <p className="text-sm text-white mb-2">{step.detail}</p>
                <div className="flex flex-wrap gap-2 text-xs items-center">
                    <span className="text-gray-400">Usa nesta etapa:</span>
                    {step.uses.length === 0 ? (
                        <span className="px-2 py-0.5 rounded bg-gray-700 text-gray-300">
                            nada desta tela (infra / grafo)
                        </span>
                    ) : (
                        step.uses.map((u) => (
                            <span
                                key={u}
                                className="px-2 py-0.5 rounded bg-[#d59106]/25 text-laranjinha border border-[#d59106]/50"
                            >
                                {USE_LABELS[u] || u}
                            </span>
                        ))
                    )}
                    {step.id === "kill" ? (
                        <span
                            className={`px-2 py-0.5 rounded border ${
                                enabled
                                    ? "border-green-600 text-green-400"
                                    : "border-red-500 text-red-300"
                            }`}
                        >
                            agora: {enabled ? "bot LIGADO" : "bot DESLIGADO (Triagem)"}
                        </span>
                    ) : null}
                </div>
            </div>

            <p className="text-xs text-gray-400 mt-3">
                Dica: clique um passo para ler; em “Simular mensagem” o fluxo avança sozinho e abre a
                seção Config relacionada quando existir.
            </p>
        </section>
    );
};

export default BotOpsPipelineTour;
